
function Logout() {
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
}

export default Logout;